<template>
    <div
        class="card-footer"
        :class="{ 'card-footer--body': inBody }"
        v-if="activeTab == 'general'"
    >
        <div class="row align-items-center">
            <div class="col text-center">
                <LoaderedButton
                    type="submit"
                    :clickHandler="submitHandler"
                    btnClasses="btn btn-primary"
                    :content="'Save' | translate"
                />
            </div>
        </div>
    </div>
</template>

<script>
import LoaderedButton from '@C/LoaderedButton';

export default {
    name: 'SettingsFooter',
    props: {
        activeTab: {
            type: String,
            required: true
        },
        submitHandler: {
            type: Function,
            required: true
        },
        inBody: {
            type: Boolean,
            required: true
        }
    },
    components: {
        LoaderedButton
    }
}
</script>

<style lang="scss" scoped>
.card-footer--body {
  border: none;

  .row {
    padding-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/stages/Widgets/SettingsFooter.vue